import { render } from "./standardItemName.vue?vue&type=template&id=7cf52bec"
import script from "./standardItemName.vue?vue&type=script&lang=js"
export * from "./standardItemName.vue?vue&type=script&lang=js"

import "./standardItemName.vue?vue&type=style&index=0&id=7cf52bec&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__